import React, { useContext, useEffect } from 'react';
import classes from './LoginPage.module.scss';
import { Container } from 'react-bootstrap';
import t from '@/utils/Language/Modal/LoginModal-translations';
import useAccount from '@/hooks/useAccount';
import useSaml from '@/hooks/useSaml';
import ContentPane from '@/components/ContentPane/ContentPane';
import LoginForm from './LoginForm';
import { SolutionContext } from '@/context/solution.context';

const LoginPage = () => {
  const { displayGoogleButton, account } = useAccount();
  const { samlPartner } = useSaml();
  const { solution, solutionName } = useContext(SolutionContext);

  const allowGoogleAuth = solution.includes?.google_auth;
  const showGoogleAuth = allowGoogleAuth && samlPartner === false;

  useEffect(() => {
    account.setNextPage('/');
    if (showGoogleAuth) {
      displayGoogleButton('googleButtonContainer');
    }
  }, [showGoogleAuth]);

  return (
    <ContentPane>
      <Container className={classes.loginPage}>
        <div className={classes.pageHeader}>
          <span className={classes.pageTitle}>
            <h4>{t('login_title', { solutionName })}</h4>
          </span>
          {showGoogleAuth && <div id="googleButtonContainer" className={classes.btnGoogle}></div>}
        </div>
        <div className={classes.pageBody}>
          <LoginForm context={'page'} />
        </div>
      </Container>
    </ContentPane>
  );
};

export default LoginPage;
